<template>
    <section class="py-20 xl:pt-[120px] xl:pb-[60px] relative will-change z-10" :data-scroll-section="inner == 'false'">
        <div class="px-content mb-16">
            <h2 class="text-4xl xl:text-heading mb-8" v-show="blockData.title">{{ blockData.title }}</h2>
            <div class="xl:max-w-[40vw]" v-show="blockData.text" v-html="blockData.text"></div>
        </div>

        <!-- filter -->
        <div class="filter-wrap px-content mb-10 grid grid-col-1 xl:grid-cols-3 xl:gap-6">
            <div class="filter-select inline-block relative mb-10 xl:mb-0">
                <div class="leading-normal mb-4">{{ __('Choose your activity', 'ccave') }}</div>
                <button type="button" class="border-b border-light-grey flex items-center cursor-pointer w-full" @click="toggle('filter-what')">
                    <svg class="mr-4" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 1L6 6L1 1" stroke="#001E31" stroke-width="1.2" stroke-linecap="square" />
                    </svg>
                    <span id="category-name" class="block py-3 text-sm text-mid-grey leading-[1.42]">{{ __('Pick Activity', 'ccave') }}</span>
                </button>
                <button type="button" v-if="activeCategory" class="block py-[14px] absolute right-10 bottom-0" @click="clearFilter('category')">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z" fill="#405664"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z" fill="#405664"/>
                    </svg>
                </button>
                <ul id="filter-what" class="bg-white absolute hidden activity-select z-[100]">
                    <li class="" v-for="(cat, index) in categories" :key="index" @click="setFilter('category', cat); toggle('filter-what')">
                        <a class="block px-6 py-4" href="javascript:void(0);">{{ cat.name }}</a>
                    </li>
                </ul>
            </div>
            <div class="filter-select inline-block relative mb-10 xl:mb-0">
                <div class="leading-normal mb-4">{{ __('Recommended Activities for', 'ccave') }} ...</div>
                <button type="button" class="border-b border-light-grey flex items-center cursor-pointer w-full" @click="toggle('filter-whom')">
                    <svg class="mr-4" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 1L6 6L1 1" stroke="#001E31" stroke-width="1.2" stroke-linecap="square" />
                    </svg>
                    <span id="tag-name" class="block py-3 text-sm text-mid-grey leading-[1.42]">{{ __('Select From Options', 'ccave') }}</span>
                </button>
                <button type="button" v-if="activeTag" class="block py-[14px] absolute right-10 bottom-0" @click="clearFilter('tag')">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z" fill="#405664"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z" fill="#405664"/>
                    </svg>
                </button>
                <ul id="filter-whom" class="bg-white absolute hidden activity-select">
                    <li class="" v-for="(tag, index) in tags" :key="index" @click="setFilter('tag', tag); toggle('filter-whom')">
                        <a class="block px-6 py-4"  href="javascript:void(0);">{{ tag.name }}</a>
                    </li>
                </ul>
            </div>
            <div class="filter-select inline-block relative">
                <div class="leading-normal mb-4">{{ __('Pick the location', 'ccave') }}</div>
                <button type="button" class="border-b border-light-grey flex items-center cursor-pointer w-full" @click="toggle('filter-where')">
                    <svg class="mr-4" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11 1L6 6L1 1" stroke="#001E31" stroke-width="1.2" stroke-linecap="square" />
                    </svg>
                    <span id="location-name" class="block py-3 text-sm text-mid-grey leading-[1.42]">{{ __('Select From Options', 'ccave') }}</span>
                </button>
                <button type="button" v-if="activeLocation" class="block py-[14px] absolute right-10 bottom-0" @click="clearFilter('location')">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.50001 2.93359L13.0657 12.4993L12.5 13.065L2.93433 3.49928L3.50001 2.93359Z" fill="#405664"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.0657 3.49928L3.50001 13.065L2.93433 12.4993L12.5 2.93359L13.0657 3.49928Z" fill="#405664"/>
                    </svg>
                </button>
                <ul id="filter-where" class="bg-white absolute hidden activity-select">
                    <li class="" v-for="(location, index) in locations" :key="index" @click="setFilter('location', location); toggle('filter-where')">
                        <a class="block px-6 py-4" href="javascript:void(0);">{{ getLocationTranslation(location.name) }}</a>
                    </li>
                </ul>
            </div>
        </div>
        <!-- ./filter -->


        <!-- activities card -->
        <div class="px-content grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
            <div class="card-activity " v-show="activities" v-for="(activity, index) in filteredActivities" :key="index" >
                <div class="overflow-hidden relative mb-5">
                    <img class="object-cover w-full h-full" v-show="activity.data.fields.image" :src="activity.data.fields.image.url" :alt="activity.data.fields.image.alt">
                </div>
                <div class="card-toponyms__txt pt-8 pl-0 pb-[18px] pr-12">
                    <h4 class="text-2xl tracking-[2px] mb-4" v-show="activity.title.rendered">{{ activity.title.rendered }}</h4>
                    <div class="mb-10 text-sm leading-[1.42] " v-show="activity.data.fields.text" v-html="activity.data.fields.text"></div>

                    <!-- picto -->
                    <div class="flex items-center mt-auto">
                        <div class="flex items-center mr-6">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.25 15C10.9424 15 13.125 12.8174 13.125 10.125C13.125 7.43261 10.9424 5.25 8.25 5.25C5.55761 5.25 3.375 7.43261 3.375 10.125C3.375 12.8174 5.55761 15 8.25 15Z"
                                    stroke="#405664" stroke-width="1.2" stroke-miterlimit="10" />
                                <path
                                    d="M14.5693 5.43271C15.2399 5.24379 15.9431 5.20075 16.6316 5.3065C17.3202 5.41224 17.9781 5.66431 18.561 6.04572C19.1439 6.42714 19.6384 6.92904 20.011 7.51763C20.3836 8.10622 20.6258 8.76783 20.7212 9.45789C20.8166 10.148 20.763 10.8504 20.564 11.5181C20.3651 12.1857 20.0253 12.8029 19.5677 13.3281C19.1102 13.8534 18.5453 14.2745 17.9113 14.5631C17.2773 14.8517 16.5887 15.001 15.8921 15.0011"
                                    stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M1.5 18.5059C2.26138 17.4229 3.27215 16.539 4.44698 15.9288C5.62182 15.3186 6.92623 15.0001 8.25008 15C9.57393 14.9999 10.8784 15.3184 12.0532 15.9285C13.2281 16.5386 14.239 17.4225 15.0004 18.5054"
                                    stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M15.8926 15C17.2166 14.999 18.5213 15.3171 19.6962 15.9273C20.8712 16.5375 21.8819 17.4218 22.6426 18.5054"
                                    stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div class="ml-3 text-sm leading-[1.42]" v-show="activity.data.fields.location">{{ getLocationTranslation(activity.data.fields.location) }}</div>
                        </div>
                        <div class="flex items-center mr-6">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
                                    stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                                <path
                                    d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
                                    stroke="#405664" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <div class="ml-3 text-sm leading-[1.42]" v-show="activity.activity_tags">{{ getActivityTagName(activity.activity_tags[0]) }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- ./activities card -->
        <div v-if="filteredActivities.length === 0" class="px-content justify-center">{{ __('Unfortunately there are no activities for the selected criteria. Please amend filters.', 'ccave') }}</div>

    </section>
</template>


<script>
    export default {
        name: 'ActivitiesList',
        data() {
            return {
                activities: false,
                categories: false,
                tags: false,
                locations: [
                    {name: 'In Luštica Bay'},
                    {name: 'Beyond Luštica Bay'},
                ],
                activeCategory: false,
                activeTag: false,
                activeLocation: false,
                isOpened: false
            }
        },
        mounted() {
            this.getActivities()
        },
        computed: {
            filteredActivities () {
                let results = this.activities
                if (this.activities) {
                    if (this.activeCategory || this.activeTag || this.activeLocation) {
                        if ( this.activeCategory ) {
                            results =  results.filter( activity => activity.activity_category.includes(this.activeCategory) )
                        }
                        if ( this.activeTag ) {
                            results = results.filter( activity => activity.activity_tags.includes(this.activeTag) )
                        }
                        if ( this.activeLocation ) {
                            results = results.filter( activity => activity.data.fields.location === this.activeLocation.name )
                        }
                    }
                }
                return results
            }
        },
        methods: {
            updateScroll() {
                /*this.$nextTick(() => {
                    setTimeout(() => {
                        this.$root.scroll.update()
                    }, 200);
                });*/
            },
            getActivities() {
                this.getActivityCategories()
                this.getActivityTags()
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/activity?per_page=100' )
                    .then( res => {
                        this.activities = res.data
                        this.updateScroll()
                    }
                );
            },
            getActivityCategories() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/activity_category' )
                    .then( res => {
                        this.categories = res.data
                    }
                );
            },
            getActivityTags() {
                this.$http.get( this.endpoints.rest_base_endpoint  + 'wp/v2/activity_tags' )
                    .then( res => {
                        this.tags = res.data
                    }
                );
            },
            getActivityTagName(id) {
                let tag = this.tags.filter(tag => tag.id === id)
                return tag[0].name
            },
            setFilter(filterName, filter) {
                if (filterName === 'category') {
                    this.activeCategory = filter.id
                    document.getElementById('category-name').innerHTML = filter.name
                    document.getElementById('category-name').classList.add('text-navy-blue-01')
                } else if (filterName === 'tag') {
                    this.activeTag = filter.id
                    document.getElementById('tag-name').innerHTML = filter.name
                    document.getElementById('tag-name').classList.add('text-navy-blue-01')
                } else if (filterName === 'location') {
                    this.activeLocation = filter
                    document.getElementById('location-name').innerHTML = this.getLocationTranslation(filter.name)
                    document.getElementById('location-name').classList.add('text-navy-blue-01')
                }
                this.updateScroll()
            },
            clearFilter(filterName) {
                if (filterName === 'category') {
                    this.activeCategory = false
                    document.getElementById('category-name').innerHTML = this.__('Pick Activity', 'ccave')
                    document.getElementById('category-name').classList.remove('text-navy-blue-01')
                } else if (filterName === 'tag') {
                    this.activeTag = false
                    document.getElementById('tag-name').innerHTML = this.__('Select From Options', 'ccave')
                    document.getElementById('tag-name').classList.remove('text-navy-blue-01')
                } else if (filterName === 'location') {
                    this.activeLocation = false
                    document.getElementById('location-name').innerHTML = this.__('Select From Options', 'ccave')
                    document.getElementById('location-name').classList.remove('text-navy-blue-01')
                }
                this.updateScroll()
            },
            toggle(id) {
                let el = document.getElementById(id)
                if ( el.classList.contains('hidden') ) {
                    el.classList.remove('hidden')
                    el.classList.add('visible')
                } else {
                    el.classList.remove('visible')
                    el.classList.add('hidden')
                }
            },
            getLocationTranslation(text) {
                if ( text === 'In Luštica Bay') {
                    return this.__('In Luštica Bay', 'ccave')
                }
                if ( text === 'Beyond Luštica Bay') {
                    return this.__('Beyond Luštica Bay', 'ccave')
                } 
            }
        },
    }
</script>
